import { AxiosResponse } from "axios";
import { authApiV2, axiosWithToast } from "../../axiosWrapper";
import { TGeneralSeaAreas, TReportRequestParams, TColumnMappings, TAreaSignalStatistics } from "./types/downloadTypes";

export const getGeneralSeaAreas = async (): Promise<TGeneralSeaAreas[]> => {
    const endpoint = `/general-sea-areas`;
    try {
        const response = await authApiV2.get(endpoint);
        return Promise.resolve(response.data as TGeneralSeaAreas[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getColumnMappings = async (): Promise<TColumnMappings[]> => {
    const endpoint = `/column-mappings`;
    try {
        const response = await authApiV2.get(endpoint);
        return Promise.resolve(response.data as TColumnMappings[]);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getAreaSignalStatistics = async (lat: number, latTo: number, lon: number, lonTo: number): Promise<TAreaSignalStatistics> => {
    const endpoint = `/area-signal-statistic?lat=${lat}&latTo=${latTo}&lon=${lon}&lonTo=${lonTo}`;
    try {
        const response = await authApiV2.get(endpoint);
        return Promise.resolve(response.data as TAreaSignalStatistics);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const requestActivityReport = async (params: TReportRequestParams): Promise<any> => {
    const endpoint = `/ais-data-request`;
    try {
        const response: AxiosResponse<any> = await axiosWithToast({
            method: 'POST',
            url: endpoint,
            withCredentials: true,
            data: params,
        }
            , "Submitting Activity Report Request..."
            , "Activity Report request submitted successfully. You will receive an email once the report is ready for download."
            , 0);

        return Promise.resolve(response.data);
    } catch (err) {
        return Promise.reject(err);
    }
};